import React, { useEffect } from "react";
import "../Styling/NotificationModal.css";

const NotificationModal = ({ notifications = [], onClose }) => {

  // Prevent background scroll when modal opens
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const getEventIcon = (eventType) => {
    switch (eventType) {
      case "Birthday":
        return "🎂";
      case "Employee Confirmation":
        return "✅";
      case "Anniversary":
        return "🎉";
      default:
        return "📅";
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className="nm-overlay" onClick={onClose}>
      <div className="nm-container" onClick={(e) => e.stopPropagation()}>

        <div className="nm-header">
          <div>
            <h3>All Notifications</h3>
            <span>{notifications.length} total notifications</span>
          </div>
          <button className="nm-close" onClick={onClose}>✖</button>
        </div>

        <div className="nm-body">
          {notifications.length === 0 ? (
            <div className="nm-empty">
              <div>📭</div>
              <p>No notifications available</p>
            </div>
          ) : (
            notifications.map((item, index) => (
              <div key={index} className="nm-card">

                <div className="nm-card-header">
                  <div className="nm-left">
                    <div className="nm-icon">
                      {getEventIcon(item.eventType)}
                    </div>
                    <div className="nm-name">
                      {item.resourceName}
                    </div>
                  </div>

                  <div className="nm-date">
                    {formatDate(item.date)}
                  </div>
                </div>

                <div className="nm-details">
                  <div>
                    <strong>Event:</strong> {item.eventType}
                  </div>
                  <div className="nm-email">
                    <strong>Email:</strong> {item.notifyTo}
                  </div>
                  <div>
                    <strong>Template:</strong> {item.templateType}
                  </div>
                </div>

              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
};

export default NotificationModal;
